
      export interface IntrospectionResultData {
        __schema: {
          types: {
            kind: string;
            name: string;
            possibleTypes: {
              name: string;
            }[];
          }[];
        };
      }
      const result: IntrospectionResultData = {
  "__schema": {
    "types": [
      {
        "kind": "INTERFACE",
        "name": "SuggestionSource",
        "possibleTypes": [
          {
            "name": "KeywordSuggestionSource"
          },
          {
            "name": "SearchSuggestionSource"
          },
          {
            "name": "MissingPopularSuggestionSource"
          },
          {
            "name": "HighDemandSuggestionSource"
          },
          {
            "name": "AwardsSuggestionSource"
          },
          {
            "name": "StaffPicksSuggestionSource"
          },
          {
            "name": "MarketSelectionSuggestionSource"
          },
          {
            "name": "CollaborativeFilteringSuggestionSource"
          }
        ]
      }
    ]
  }
};
      export default result;
    